import { useTranslation } from "react-i18next";
import toLocaleStringCustom from "../../../HelpersFunctions/dateAndTime/toLocaleStringCustom";
import AccordionStyled from "../MaterialUi/Accordion/AccordionStyled";
import styles from "./styles.module.scss";

interface IGuest {
  id: number;
  firstName: string;
  lastName: string;
  dateOfBirth: Date | null;
  email: string;
  trainingExpiryDate: Date | null;
  addingPersonId: number;
  createdAt: Date;
  companyName: string;
  iDNumber: string;
}

interface IGuestInfo {
  guest: IGuest;
  letIn: boolean | null;
  securityFullName: string | null;
  securityDateConfirmation: Date | null;
  securityRejectionReason: string;
}

interface IProps {
  guestsInfo: IGuestInfo[];
  defaultExpanded?: boolean;
  onlyNames?: boolean;
}

const GuestsList: React.FC<IProps> = ({
  guestsInfo,
  defaultExpanded,
  onlyNames,
}) => {
  const { t } = useTranslation();

  return (
    <AccordionStyled
      title={`${t("persons")} (${guestsInfo.length})`}
      defaultExpanded={defaultExpanded}
    >
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>{t("first_name")}</th>
              <th>{t("last_name")}</th>
              {!onlyNames && <th>{t("email")}</th>}
              {!onlyNames && <th>{t("date_of_birth")}</th>}
              {!onlyNames && <th>{t("training_expiry_date")}</th>}
              <th>{t("is_letted_in")}</th>
              <th>{t("rejection_reason")}</th>
            </tr>
          </thead>
          <tbody>
            {guestsInfo.map((item) => {
              const guest = item.guest;

              return (
                <tr
                  key={guest.id}
                  className={
                    item.letIn === true
                      ? styles.lettedIn
                      : item.letIn === false
                      ? styles.notLettedIn
                      : ""
                  }
                >
                  <td>{guest.firstName}</td>
                  <td>{guest.lastName}</td>
                  {!onlyNames && (
                    <>
                      <td>{guest.email ? guest.email : "-"}</td>
                      <td>
                        {guest.dateOfBirth
                          ? toLocaleStringCustom({
                              date: guest.dateOfBirth,
                              t,
                            })
                          : "-"}
                      </td>
                      <td>
                        {guest.trainingExpiryDate
                          ? toLocaleStringCustom({
                              date: guest.trainingExpiryDate,
                              t,
                            })
                          : "-"}
                      </td>
                    </>
                  )}
                  <td>
                    {item.letIn !== null
                      ? item.letIn === true
                        ? `${t("yes").toUpperCase()} (${t("by")} ${
                            item.securityFullName
                          })`
                        : `${t("no").toUpperCase()} (${t("by")} ${
                            item.securityFullName
                          })`
                      : "-"}
                  </td>
                  <td>
                    {!item.securityRejectionReason.includes("null")
                      ? item.securityRejectionReason.replaceAll("null", "")
                      : "-"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </AccordionStyled>
  );
};

export default GuestsList;
